import { Form, Input, Modal, Select } from 'antd';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { MotivoAulaNaoOcorrida } from '../../../../../../../models/happy-code-api.model';

export interface AulaNaoOcorridaFormValues {
  motivo: MotivoAulaNaoOcorrida;
  descricao?: string;
}

interface AulaNaoOcorridaModalProps {
  open: boolean;
  loading: boolean;
  onCancel: () => void;
  onSubmit: (values: AulaNaoOcorridaFormValues) => void;
}

export default function AulaNaoOcorridaModal({
  open,
  loading,
  onCancel,
  onSubmit
}: AulaNaoOcorridaModalProps) {
  const [form] = Form.useForm<AulaNaoOcorridaFormValues>();
  const { t } = useTranslation('gestao_de_aulas');
  const motivo = Form.useWatch('motivo', form);

  useEffect(() => {
    if (!open) form.resetFields();
  }, [form, open]);

  return (
    <Modal
      open={open}
      title={t('gestao_de_aulas:lessonNotOccurredModalTitle')}
      okText={t('gestao_de_aulas:save')}
      okButtonProps={{ danger: true }}
      cancelText={t('gestao_de_aulas:cancel')}
      confirmLoading={loading}
      onCancel={onCancel}
      onOk={() => form.submit()}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={onSubmit}>
        <Form.Item
          label={t('gestao_de_aulas:lessonNotOccurredReason')}
          name="motivo"
          rules={[{
            required: true,
            message: t('gestao_de_aulas:lessonNotOccurredReasonRequired')
          }]}
        >
          <Select
            placeholder={t('gestao_de_aulas:lessonNotOccurredReasonPlaceholder')}
            options={[
              { value: 'FERIADO', label: t('gestao_de_aulas:notOccurredReasons.holiday') },
              { value: 'RECESSO', label: t('gestao_de_aulas:notOccurredReasons.break') },
              { value: 'FALTA_MENTOR', label: t('gestao_de_aulas:notOccurredReasons.mentorAbsent') },
              { value: 'OUTRO', label: t('gestao_de_aulas:notOccurredReasons.other') }
            ]}
          />
        </Form.Item>

        <Form.Item
          label={t('gestao_de_aulas:lessonNotOccurredDescription')}
          name="descricao"
          rules={[
            {
              max: 100,
              message: t('gestao_de_aulas:lessonNotOccurredDescriptionMax')
            },
            {
              validator: (_, value?: string) => {
                if (motivo === 'OUTRO' && !value?.trim()) {
                  return Promise.reject(new Error(t('gestao_de_aulas:lessonNotOccurredDescriptionRequired')));
                }
                return Promise.resolve();
              }
            }
          ]}
        >
          <Input.TextArea
            maxLength={100}
            rows={3}
            placeholder={t('gestao_de_aulas:lessonNotOccurredDescriptionPlaceholder')}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
